<script setup lang="ts">
  import { Document } from '@/entities/Document';
  import ResearchIcon from '@/shared/assets/icons/ResearchIcon.svg';
  import { IconImage } from '@/shared/ui';

  const props = defineProps<{
    docs: Document[];
  }>();
</script>

<template>
  <tr
    v-for="doc in props.docs"
    :key="doc.id"
  >
    <td>
      <div
        class="flex items-center gap-2 p-2 rounded-lg transition-all duration-300 ease-out hover:bg-off-white"
      >
        <div class="text-gray-xx px-3 py-2 pr-0">
          <IconImage
            :src="ResearchIcon"
            alt="File"
            class="min-h-5 min-w-5"
          />
        </div>
        <div>
          <div class="text-sm text-gray-07">
            {{ doc.name ?? '' }}
          </div>
        </div>
      </div>
    </td>
  </tr>
  <tr v-if="props.docs.length === 0">
    <td>
      <div
        class="flex items-center gap-2 p-2 rounded-lg transition-all duration-300 ease-out hover:bg-off-white"
      >
        <div class="text-gray-xx px-3 py-2 pr-0">
          <IconImage
            :src="ResearchIcon"
            alt="File"
            class="min-h-5 min-w-5"
          />
        </div>
        <div>
          <div class="text-sm text-gray-07">
            Nenhum resultado encontrado
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>
